import { render, staticRenderFns } from "./PlatformHistory.vue?vue&type=template&id=2ba24e10&"
import script from "./PlatformHistory.vue?vue&type=script&lang=js&"
export * from "./PlatformHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports